import Alert from "../alert";
import { useState } from "react";

function DeleteUserModal({ showDeleteuser, handleClose }) {
    const [viewAlert, setViewAlert] = useState(false);

    return (
        <>

            {/* Alert */}
            <Alert
                show={viewAlert}
                message="User removed successfully!"
                type="success"
                onClose={() => setViewAlert(false)}
            />
            <div
                className={`modal fade ${showDeleteuser ? "show d-block" : ""}`}
                tabIndex="-1"
                style={{
                    backgroundColor: showDeleteuser ? "rgba(0,0,0,0.5)" : "transparent"
                }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        {/* Header */}
                        <div className="modal-header justify-content-center">
                            <h5 className="modal-title text-center w-100">
                                <strong>Confirmation</strong>
                            </h5>

                            <button
                                type="button"
                                className="btn-close position-absolute end-0 me-3"
                                onClick={handleClose}
                            ></button>
                        </div>

                        {/* Body */}
                        <div className="modal-body text-center">
                            <p className="mb-0">
                                Are you sure you want to remove this user?
                            </p>
                        </div>

                        {/* Footer */}
                        <div className="modal-footer justify-content-center">

                            <button
                                type="button"
                                className="btn btn-secondary me-2"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>

                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => {
                                    setViewAlert(true);
                                    handleClose();
                                }}
                            >
                                Remove
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default DeleteUserModal;